import { authClient } from "~/lib/auth";

type SessionData = NonNullable<ReturnType<typeof authClient.useSession>["data"]>;

/** Synced from the live session so analytics helpers can gate without hooks. */
let supportViewActive = false;

export function setSupportViewActive(active: boolean): void {
  supportViewActive = active;
}

export function isSupportViewActive(): boolean {
  return supportViewActive;
}

export function isImpersonationSession(session: SessionData | null | undefined): boolean {
  return Boolean(
    (session?.session as { impersonatedBy?: string | null } | undefined)?.impersonatedBy,
  );
}

export async function exchangeImpersonationCode(code: string): Promise<void> {
  const baseURL = import.meta.env.VITE_APP_URL?.replace(/\/$/, "") ?? "";
  const response = await fetch(`${baseURL}/auth/impersonation/exchange`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  if (!response.ok) {
    let message = "Deze support-link is ongeldig of verlopen.";
    try {
      const body = (await response.json()) as { message?: string };
      if (body.message) message = body.message;
    } catch {
      // keep default
    }
    throw new Error(message);
  }
}
